import { useQuery } from 'react-query';
import { API } from '../../CommonUtils/axiosWithDefaults';
import { BatchStatusResult, isBatchInProgress } from './pdfBatchTypes';

const fetchAllBatches = async (): Promise<BatchStatusResult[]> => {
  return API.get('/Adviser/PdfImport/AllBatches');
};

export const allBatchesQueryKey = ['pdfImportAllBatches'];

export const usePdfAllBatchesQuery = () => {
  return useQuery(allBatchesQueryKey, fetchAllBatches, {
    refetchInterval: (data) => {
      const hasActiveBatch = data?.some(isBatchInProgress);
      return hasActiveBatch ? 3000 : false;
    },
  });
};
